<!-- Rendered in the app header's centre slot (HeaderContentService), not in
     this page's own layout. -->
<ng-template #headerMenu>
    <div class="header-page-title">จัดการสินค้าคืนเข้าสต็อก</div>
</ng-template>

<div class="dx-card padding-content">
    <div class="toolbar">
        <a
            class="text-link"
            title="กลับไปหน้าพัสดุคืนสินค้า"
            (click)="backToReturns()"
            >← พัสดุคืนสินค้า</a
        >
        <div class="summary">
            @if (loading) {
                <dx-load-indicator
                    class="inline-spinner"
                    [height]="16"
                    [width]="16"
                ></dx-load-indicator>
                กำลังดึงข้อมูลคืนสินค้า… ({{ reports.length }}/{{ storeCount }}
                ร้าน) ·
            }
            {{ rowCount }} รายการสินค้าที่ต้องเพิ่มสต็อกเอง ·
            <b>{{ pendingCount }}</b> รอตรวจสอบ · เข้าสต็อก
            {{ restockedUnits }} ชิ้น · ตัดจำหน่าย {{ writtenOffUnits }} ชิ้น
            @if (hiddenAutoPackages > 0) {
                ·
                <span class="muted-note"
                    >ไม่แสดง {{ hiddenAutoPackages }} พัสดุที่ lnwshop
                    คืนสต็อกให้เอง</span
                >
            }
            @if (checkingLnwshop) {
                ·
                <span class="muted-note">กำลังตรวจกับข้อมูล lnwshop…</span>
            }
            @if (lnwshopCheckFailed) {
                ·
                <span class="warn"
                    >ตรวจกับข้อมูล lnwshop ไม่ได้ —
                    รายการที่ซ่อนอาจมีที่ต้องเพิ่มสต็อกเอง</span
                >
            }
            @if (doubleCountedRows > 0) {
                ·
                <span class="warn"
                    >{{ doubleCountedRows }} รายการ lnwshop คืนสต็อกซ้ำ —
                    ต้องหักออก</span
                >
            }
            @if (!inspectionsLoaded) {
                ·
                <span class="warn"
                    >ยังโหลดผลตรวจสอบไม่ได้ — ดูได้อย่างเดียว</span
                >
            }
            @for (report of failedReports; track report.storeId) {
                ·
                <span class="warn">{{ report.title }}: {{ report.error }}</span>
            }
        </div>

        <div class="toolbar-right">
            <dx-check-box
                [(value)]="onlyPending"
                text="แสดงเฉพาะที่ยังตรวจไม่ครบ"
                hint="ซ่อนรายการที่ตรวจสอบครบทุกชิ้นแล้ว"
                (onValueChanged)="onFilterChanged()"
            ></dx-check-box>
            <dx-number-box
                [disabled]="loading"
                [showSpinButtons]="false"
                format="#,##0 วัน"
                [min]="7"
                [max]="365"
                label="แสดงคำขอคืนสินค้าภายใน"
                labelMode="floating"
                [(value)]="lookbackDays"
                [width]="210"
                (onEnterKey)="load()"
            ></dx-number-box>
            <dx-button
                [disabled]="loading"
                stylingMode="contained"
                icon="refresh"
                hint="ดึงข้อมูลคืนสินค้าจากทุกร้านใหม่"
                (onClick)="load()"
            ></dx-button>
        </div>
    </div>

    <!-- What the page lists and why — open until the operator folds it. -->
    <details class="explain" open>
        <summary>หน้านี้แสดงอะไร</summary>
        <ul>
            <li>
                <b>แสดงเฉพาะสินค้าที่ต้องเพิ่มสต็อกใน lnwshop เอง</b> —
                คืนสินค้า Shopee และ TikTok, Shopee
                ที่ผู้ซื้อขอคืนเงินระหว่างขนส่ง (พัสดุตีกลับด้วยเลขพัสดุเดิม)
                และ Lazada ที่คืนไม่ครบทั้งคำสั่งซื้อ: lnwshop ยังนับเป็นขายอยู่
                ตรวจสินค้าแล้วบันทึกเข้าสต็อกหรือตัดจำหน่าย และเพิ่มสต็อกใน
                lnwshop
            </li>
            <li>
                <b>ไม่แสดงพัสดุที่ lnwshop คืนสต็อกให้เอง</b> — พัสดุตีกลับของ
                Lazada / Shopee / TikTok และ Lazada ที่คืนครบทั้งคำสั่งซื้อ:
                lnwshop ยกเลิกการขายเองเมื่อแพลตฟอร์มยกเลิกคำสั่งซื้อหรือคืนเงิน
                <b>ห้ามเพิ่มสต็อกซ้ำ</b> — ถ้าสินค้าชิ้นไหนชำรุดหรือขาด
                ให้หักสต็อกใน lnwshop เอง
            </li>
            <li>
                ตรวจกับข้อมูล lnwshop ทุกคืน
                @if (lnwshopCrawledAt) {
                    (รอบล่าสุด {{ lnwshopCrawledAt | thaiDateTime }})
                }
                — ถ้า lnwshop ไม่ได้คืนสต็อกตามที่ควร
                รายการนั้นจะกลับมาแสดงที่นี่
            </li>
        </ul>
    </details>

    <dx-data-grid
        id="returnInspectionGrid"
        height="100%"
        [dataSource]="dataSource"
        keyExpr="key"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [allowColumnResizing]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true"
        [wordWrapEnabled]="false"
        [noDataText]="
            loading
                ? 'กำลังโหลด…'
                : onlyPending
                  ? 'ไม่มีสินค้าคืนที่รอตรวจสอบ'
                  : 'ไม่มีสินค้าคืนจากพัสดุที่รับแล้ว'
        "
        (onRowPrepared)="onRowPrepared($event)"
    >
        <dxo-paging [pageSize]="50"></dxo-paging>
        <dxo-pager
            [showPageSizeSelector]="true"
            [allowedPageSizes]="[25, 50, 100]"
            [showInfo]="true"
        ></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxi-column
            dataField="storeTitle"
            caption="ร้านค้า"
            [width]="140"
        ></dxi-column>
        <dxi-column
            dataField="receivedAtDate"
            caption="รับพัสดุเมื่อ"
            dataType="date"
            [width]="120"
            sortOrder="desc"
            cellTemplate="relativeDatetimeCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="sourceLabel"
            caption="ประเภท"
            [width]="110"
            alignment="center"
            cellTemplate="sourceCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="orderNo"
            caption="เลขคำสั่งซื้อ"
            [width]="170"
        ></dxi-column>
        <dxi-column
            dataField="trackingNumber"
            caption="เลขพัสดุ"
            [width]="150"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="sku"
            caption="SKU"
            [width]="110"
            cellTemplate="skuCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="name"
            caption="สินค้า"
            [minWidth]="160"
            [allowHeaderFiltering]="false"
            cellTemplate="nameCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="qty"
            caption="จำนวน"
            dataType="number"
            [width]="80"
            alignment="center"
            [allowHeaderFiltering]="false"
        ></dxi-column>
        <dxi-column
            dataField="statusLabel"
            caption="สถานะ"
            [width]="120"
            cellTemplate="statusCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="restocked"
            caption="เข้าสต็อก"
            dataType="number"
            [width]="90"
            alignment="center"
            [allowHeaderFiltering]="false"
            cellTemplate="countCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="writtenOff"
            caption="ตัดจำหน่าย"
            dataType="number"
            [width]="95"
            alignment="center"
            [allowHeaderFiltering]="false"
            cellTemplate="countCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="note"
            caption="หมายเหตุ"
            [minWidth]="140"
            [allowHeaderFiltering]="false"
            cellTemplate="noteCellTemplate"
        ></dxi-column>
        <dxi-column
            dataField="markedAt"
            caption="บันทึกเมื่อ"
            [width]="110"
            [allowFiltering]="false"
            cellTemplate="markedCellTemplate"
        ></dxi-column>
        <dxi-column
            caption=""
            [width]="150"
            [allowFiltering]="false"
            [allowSorting]="false"
            cellTemplate="actionsCellTemplate"
        ></dxi-column>

        <div *dxTemplate="let cellData of 'relativeDatetimeCellTemplate'">
            <span [title]="cellData.data.receivedAt | thaiDateTime">
                {{ cellData.value | formatRelativeDatetime: "th" }}
            </span>
        </div>
        <!-- The type opens the package's detail popup. -->
        <div
            *dxTemplate="let cellData of 'sourceCellTemplate'"
            class="source-cell"
        >
            <span
                class="source source-button source-{{ cellData.data.source }}"
                [title]="cellData.data.restockNote + ' · คลิกดูรายละเอียด'"
                (click)="openDetail(cellData.data, $event)"
                >{{ cellData.value }}</span
            >
        </div>
        <div *dxTemplate="let cellData of 'skuCellTemplate'">
            <a
                class="sku-link"
                (click)="openProduct(cellData.value); $event.stopPropagation()"
                >{{ cellData.value }}</a
            >
        </div>
        <div
            *dxTemplate="let cellData of 'nameCellTemplate'"
            class="cell-ellipsis"
            [title]="cellData.value"
        >
            {{ cellData.value }}
        </div>
        <div *dxTemplate="let cellData of 'statusCellTemplate'">
            <span class="status status-{{ cellData.data.status }}">
                {{ cellData.value }}
            </span>
        </div>
        <!-- Shared by the เข้าสต็อก and ตัดจำหน่าย columns: green for units
             back on the shelf, red for units gone, so the two cannot be
             misread for each other at a glance. -->
        <div *dxTemplate="let cellData of 'countCellTemplate'">
            @if (cellData.value > 0) {
                <b
                    class="count"
                    [class.count-restocked]="
                        cellData.column.dataField === 'restocked'
                    "
                    [class.count-written-off]="
                        cellData.column.dataField === 'writtenOff'
                    "
                    >{{ cellData.value }}</b
                >
            } @else {
                <span class="muted">–</span>
            }
        </div>
        <div
            *dxTemplate="let cellData of 'noteCellTemplate'"
            class="cell-ellipsis"
            [title]="cellData.value"
        >
            {{ cellData.value }}
        </div>
        <div *dxTemplate="let cellData of 'markedCellTemplate'">
            @if (cellData.value) {
                <span
                    [title]="
                        (cellData.value | thaiDateTime) +
                        (cellData.data.markedBy
                            ? ' · ' + cellData.data.markedBy
                            : '')
                    "
                >
                    {{ cellData.value | formatRelativeDatetime: "th" }}
                </span>
            }
        </div>
        <div
            *dxTemplate="let cellData of 'actionsCellTemplate'"
            class="actions-cell"
        >
            <!-- Icons only: with labels the four buttons ran past the
                 viewport. Each one's label lives in its hover hint. -->
            @if (cellData.data.status === "pending") {
                <dx-button
                    stylingMode="outlined"
                    type="success"
                    icon="plus"
                    hint="เข้าสต็อก — ทุกชิ้นขายต่อได้ นำกลับเข้าสต็อกแล้ว"
                    [disabled]="saving || !inspectionsLoaded"
                    (onClick)="restockAll(cellData.data)"
                ></dx-button>
                <dx-button
                    stylingMode="outlined"
                    type="danger"
                    icon="trash"
                    hint="ตัดจำหน่าย — ทุกชิ้นขายต่อไม่ได้"
                    [disabled]="saving || !inspectionsLoaded"
                    (onClick)="writeOffAll(cellData.data)"
                ></dx-button>
                <dx-button
                    stylingMode="text"
                    icon="edit"
                    hint="แยกจำนวน / ใส่หมายเหตุ"
                    [disabled]="saving || !inspectionsLoaded"
                    (onClick)="openEdit(cellData.data)"
                ></dx-button>
            } @else {
                <dx-button
                    stylingMode="outlined"
                    icon="edit"
                    hint="แก้ไขจำนวนหรือหมายเหตุ"
                    [disabled]="saving || !inspectionsLoaded"
                    (onClick)="openEdit(cellData.data)"
                ></dx-button>
                <dx-button
                    stylingMode="text"
                    icon="revert"
                    hint="ล้างผลตรวจสอบของรายการนี้"
                    [disabled]="saving || !inspectionsLoaded"
                    (onClick)="clearMark(cellData.data)"
                ></dx-button>
            }
            @if (cellData.data.adminUrl) {
                <a
                    class="admin-link dx-icon-export"
                    [href]="cellData.data.adminUrl"
                    target="_blank"
                    title="เปิดหน้าสินค้าใน lnwstore เพื่อคีย์สต็อก"
                    (click)="$event.stopPropagation()"
                ></a>
            }
        </div>
    </dx-data-grid>
</div>

<app-product-card-popup #productCard></app-product-card-popup>

<app-return-detail-popup
    #detailPopup
    (skuClick)="openProduct($event)"
></app-return-detail-popup>

<dx-popup
    [(visible)]="editPopupVisible"
    [showTitle]="true"
    [title]="'บันทึกผลตรวจสอบ ' + (editRow?.sku ?? '')"
    [dragEnabled]="true"
    [hideOnOutsideClick]="!saving"
    [showCloseButton]="true"
    [width]="420"
    height="auto"
>
    @if (editRow; as row) {
        <div class="edit-form">
            <div class="edit-hint">
                {{ row.name || row.sku }} · รับคืน {{ row.qty }} ชิ้น ·
                คำสั่งซื้อ {{ row.orderNo }}
            </div>
            <div class="edit-row">
                <dx-number-box
                    label="นำเข้าสต็อก (ชิ้น)"
                    labelMode="floating"
                    format="#,##0"
                    [min]="0"
                    [max]="row.qty"
                    [showSpinButtons]="true"
                    [(value)]="editRestocked"
                ></dx-number-box>
                <dx-number-box
                    label="ตัดจำหน่าย (ชิ้น)"
                    labelMode="floating"
                    format="#,##0"
                    [min]="0"
                    [max]="row.qty"
                    [showSpinButtons]="true"
                    [(value)]="editWrittenOff"
                ></dx-number-box>
            </div>
            @if (editOverflow) {
                <div class="warn">
                    รวม {{ editTotal }} ชิ้น มากกว่าที่รับคืน ({{ row.qty }})
                </div>
            } @else if (editTotal < row.qty) {
                <div class="edit-hint">
                    ยังเหลืออีก {{ row.qty - editTotal }} ชิ้นที่ยังไม่ระบุ —
                    บันทึกได้ จะขึ้นสถานะ "ตรวจบางส่วน"
                </div>
            }
            <dx-text-box
                label="หมายเหตุ (เหตุผลที่ตัดจำหน่าย ฯลฯ)"
                labelMode="floating"
                [(value)]="editNote"
                [showClearButton]="true"
                (onEnterKey)="saveEdit()"
            ></dx-text-box>
            <div class="edit-actions">
                <dx-button
                    stylingMode="outlined"
                    text="ยกเลิก"
                    [disabled]="saving"
                    (onClick)="editPopupVisible = false"
                ></dx-button>
                <dx-button
                    stylingMode="contained"
                    type="default"
                    text="บันทึก"
                    [disabled]="saving || editOverflow"
                    (onClick)="saveEdit()"
                ></dx-button>
            </div>
        </div>
    }
</dx-popup>
